import axios from 'axios'
import { getRuntimeConfig } from '../config/runtime'

const instance = axios.create({
  baseURL: (getRuntimeConfig() && getRuntimeConfig().API_BASE) || import.meta.env.VITE_API_BASE,
  timeout: 10000
})

instance.interceptors.request.use(cfg => {
  try {
    const base = (getRuntimeConfig() && getRuntimeConfig().API_BASE) || import.meta.env.VITE_API_BASE
    instance.defaults.baseURL = base
  } catch (e) {
    // ignore
  }
  const token = localStorage.getItem('TOKEN')
  if (token) {
    cfg.headers = cfg.headers || {}
    cfg.headers.Authorization = `Bearer ${token}`
  }
  return cfg
})

instance.interceptors.response.use(
  res => {
    // 如果后端有 { code, data, msg } 约定，可以在此统一处理
    return res.data !== undefined ? res.data : res
  },
  err => Promise.reject(err)
)

export default instance
export const get = (url, params, cfg) => instance.get(url, { params, ...cfg })
export const post = (url, data, cfg) => instance.post(url, data, cfg)
export const put = (url, data, cfg) => instance.put(url, data, cfg)
export const del = (url, cfg) => instance.delete(url, cfg)
